<template>
  <div class="page">
    <parallax-container class="page">
      <parallax-element :parallaxStrength="3" :type="'translation'" class="lt"></parallax-element>
      <parallax-element :parallaxStrength="2" :type="'translation'" class="product-pack" link="http://espumisan.ru/instructions/espumizan-extra/index.phtml?utm_source=Afisha&utm_medium=Branding&utm_campaign=Espumisan_adults_2018" @click="$ga.event('Ссылки', 'продукт на главной', 1)">
        <img src="../../assets/img/pack.png" alt=""></parallax-element>
      <parallax-element :parallaxStrength="3" :type="'translation'" class="rt"></parallax-element>
      <parallax-element :parallaxStrength="3" :type="'translation'" class="rm"></parallax-element>
      <parallax-element :parallaxStrength="3" :type="'translation'" class="rb"></parallax-element>
      <parallax-element :parallaxStrength="3" :type="'translation'" class="bm"></parallax-element>
      <parallax-element :parallaxStrength="3" :type="'translation'" class="lb"></parallax-element>
      <parallax-element :parallaxStrength="5" :type="'translation'" class="lm"></parallax-element>
      <div class="screen">
        <parallax-container class="content">

            <h1>Путь к успеху</h1>
            <p>Ответственное собеседование, путешествие мечты или, например, свадьба лучшей подруги – любое из этих
              событий может внезапно пойти не так, как вы запланировали. Узнайте о том, с какими неожиданными проблемами
              вы можете столкнуться, и решите, как поступить в этих ситуациях правильно.</p>
          <div class="persons">

                <div class="person" @click="linkTo('svetlana')">
                  <div class="person-image person-1"></div>
                  <div class="person-text person-1">Погуляйте <br>
                    на свадьбе
                  </div>
                </div>

              <div class="person" style="padding-top: 3vh" @click="linkTo('elena')">
                <div class="person-text person-2">Пройдите
                  <br>
                  собеседование
                </div>
                <div class="person-image person-2"></div>

              </div>

              <div class="person" @click="linkTo('maria')">
                <div class="person-image person-3"></div>
                <div class="person-text person-3">Отправьтесь
                  <br>
                  в путешествие
                </div>
              </div>

          </div>
        </parallax-container>
      </div>
    </parallax-container>
    <div class="afishaLink">
      <a @click="$ga.event('Ссылка', 'Афиша', 1)" href="https://www.afisha.ru/"  target="_blank"><span class="afisha"></span></a>
    </div>
    <div class="shareBlock">
      <share-block></share-block>
    </div>
    <bot-block></bot-block>
  </div>
</template>

<script>
import parallaxContainer from "@/components/parallax/parallax-container.vue";
import parallaxElement from "@/components/parallax/parallax-element.vue";
import BotBlock from "@/components/BotBlock.vue";
import TopBlock from "@/components/TopBlock.vue";
import ShareBlock from "@/components/ShareBlock.vue";

export default {
  name: "IndexDesktop",
  components: {
    parallaxContainer,
    parallaxElement,
    BotBlock,
    TopBlock,
    ShareBlock
  },
  methods: {
    linkTo(name) {
      this.$router.push(name);
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background: #fbfdfe;
}

.screen {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.lt {
  position: absolute;
  max-width: 500px;
  max-height: 501px;
  left: -100px;
  top: 0;
  max-width: 500px;
  max-height: 501px;
  height: 69vmin;
  width: 69vmin;
  background: url("../../assets/img/index/lt.png") no-repeat top left;
  background-size: contain;
}

.rt {
  position: absolute;
  right: -30px;
  top: 3.4vh;
  max-width: 240px;
  max-height: 235px;
  width: 33vmin;
  height: 32vmin;
  background-image: url("../../assets/img/index/rt.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top right;
}

.rm {
  position: absolute;
  background-image: url("../../assets/img/index/rm.png");
  right: -90px;
  bottom: 32%;
  max-height: 221px;
  max-width: 221px;
  width: 31vmin;
  height: 31vmin;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top right;
  z-index: 2;
}

.rb {
  position: absolute;
  background-image: url("../../assets/img/index/rb.png");
  max-width: 315px;
  max-height: 465px;
  right: -115px;
  bottom: -30px;
  width: 41vmin;
  height: 59vmin;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right bottom;
}

.lb {
  position: absolute;
  background-image: url("../../assets/img/index/lb.png");
  max-width: 342px;
  max-height: 364px;
  left: -109px;
  bottom: -48px;
  width: 52vmin;
  height: 52vmin;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}

.bm {
  position: absolute;
  left: 31.7%;
  bottom: 0;
  max-width: 483px;
  max-height: 99px;
  width: 38vw;
  height: 15vmin;
  background-size: contain;
  background: url("../../assets/img/index/bm.png") no-repeat center bottom;
}

.lm {
  position: absolute;
  left: -35px;
  bottom: 34%;
  max-width: 222px;
  max-height: 173px;
  width: 39vmin;
  height: 38vmin;
  background: url("../../assets/img/index/lm.png") no-repeat bottom left;
  background-size: contain;
}

.afishaLink {
  position: absolute;
  right: 26px;
  top: 23px;
  width: 75px;
  height: 30px;
  a {
    width: 75px;
    height: 30px;
    display: block;
  }
  .afisha {
    width: 75px;
    height: 30px;
    background: url("../../assets/img/afisha-d.png") no-repeat;
    background-size: contain;
    display: block;
  }
}

.shareBlock {
  top: auto;
  bottom: 3.3vh;
  left: auto;
  right: 24px;
  z-index: 1000;
  display: block;
  position: absolute;
}

@media screen and (min-width: 768px) {
  .page {
    min-height: 0;
  }

  h1 {
    font-family: "Playfair Display", serif;
    color: #323232;
    font-weight: 700;
    font-style: italic;
    line-height: 20px; /* Приближение из-за подстановки шрифтов */
    text-align: center;
    margin-top: 31px;
    font-size: 56px;
  }
  p {
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 400;
    max-width: 670px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .content {
    margin: 0 auto;
    position: relative;
    z-index: 20;
  }
  .persons {
    max-width: 830px;
    width: 65vw;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-bottom: 6vh;
    margin-top: 45px;
  }
  .person {
    cursor: pointer;
    .person-text {
      font-family: "Playfair Display", serif;
      color: #323232;
      font-style: italic;
      text-align: left;
      background-repeat: no-repeat;
      background-size: auto 100%;
      padding-bottom: 17px;
      padding-top: 12px;
      display: block;
      margin: auto;
      font-size: 33px;
      line-height: 33px;
      &.person-1 {
        background-image: url("../../assets/img/index/1-d.png");
        width: 165px;
        margin-left: 12px;
        margin-top: 23px;
      }
      &.person-2 {
        background-image: url("../../assets/img/index/2.png");
        width: 174px;
      }
      &.person-3 {
        background-image: url("../../assets/img/index/3.png");
        width: 236px;
        margin-right: -20px;
        margin-top: 30px;
      }
    }
    .person-image {
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 auto;
      &.person-1 {
        background-image: url("../../assets/img/index/person1.png");
        width: 229px;
        height: 302px;
      }
      &.person-2 {
        background-image: url("../../assets/img/index/person2.png");
        width: 229px;
        height: 302px;
        background-position: bottom center;
      }
      &.person-3 {
        background-image: url("../../assets/img/index/person3.png");
        width: 272px;
        height: 301px;
      }
    }
    &:hover {
      .person-text {
        &.person-1 {
          background-image: url("../../assets/img/index/1-h.png");
        }
        &.person-2 {
          background-image: url("../../assets/img/index/2-h.png");
        }
        &.person-3 {
          background-image: url("../../assets/img/index/3-h.png");
        }
      }
      .person-image {
        filter: drop-shadow(0 0 15px rgba(255, 250, 145, 0.77));
        &.person-1 {
          background-image: url("../../assets/img/index/person1.png");
        }
        &.person-2 {
          background-image: url("../../assets/img/index/person2.png");
          background-position: bottom center;
        }
        &.person-3 {
          background-image: url("../../assets/img/index/person3.png");
        }
      }
    }
  }

  .product-pack {
    width: 123px;
    height: 115px;
    position: absolute;
    left: 55px;
    top: 80px;
    img {
      filter: drop-shadow(0 0 16px rgba(255, 223, 16, 0.6));
      transition: all 300ms ease-in-out;
      &:hover {
        filter: drop-shadow(0 0 16px rgba(50, 164, 78, 0.6));
        transform: rotate(-20deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IndexPage/IndexDesktop.vue